/**
 * Local Delivery Cart validation + seasonal hint controller.
 */
(function () {
  'use strict';

  function getCheckoutProxyButton() {
    if (typeof document.querySelector !== 'function') return null;
    return document.querySelector('[data-sgf-cart-checkout-proxy]') ||
      document.getElementById('custom-showRecommendationsBtn');
  }

  function createValidationController(ctx) {
    ctx = ctx || {};

    function normalizeShopifyNumericId(value) {
      var raw = String(value == null ? '' : value).trim();
      if (!raw) return '';
      var gidMatch = raw.match(/\/(\d+)$/);
      if (gidMatch && gidMatch[1]) return gidMatch[1];
      var numericMatch = raw.match(/(\d+)/);
      return numericMatch && numericMatch[1] ? numericMatch[1] : '';
    }

    function getSeasonalWindowsForVariant(seasonalData, variantId) {
      if (!seasonalData || variantId == null) return null;
      var raw = String(variantId).trim();
      var normalized = normalizeShopifyNumericId(raw);
      var candidates = [raw];

      if (normalized) {
        candidates.push(normalized);
        candidates.push('gid://shopify/ProductVariant/' + normalized);
        candidates.push('shopify-variant-' + normalized);
        candidates.push('shopify-variant-gid://shopify/ProductVariant/' + normalized);
      }

      for (var i = 0; i < candidates.length; i++) {
        var key = candidates[i];
        if (key && seasonalData[key]) return seasonalData[key];
      }

      if (!normalized) return null;

      var keys = Object.keys(seasonalData);
      for (var j = 0; j < keys.length; j++) {
        if (normalizeShopifyNumericId(keys[j]) === normalized) {
          return seasonalData[keys[j]];
        }
      }

      return null;
    }

    function getEl(id) {
      return ctx.dom && typeof ctx.dom.getEl === 'function' ? ctx.dom.getEl(id) : null;
    }

    function getForm() {
      if (ctx.dom && typeof ctx.dom.getForm === 'function') return ctx.dom.getForm();
      return (document.getElementById('cart') || document.getElementById('cart_form'));
    }

    function getSeasonalData() {
      return ctx.getters && ctx.getters.getSeasonalData ? ctx.getters.getSeasonalData() : null;
    }

    function getSeasonalDataPromise() {
      return ctx.getters && ctx.getters.getSeasonalDataPromise ? ctx.getters.getSeasonalDataPromise() : null;
    }

    function getSeasonalCheckPending() {
      return ctx.getters && ctx.getters.getSeasonalCheckPending ? ctx.getters.getSeasonalCheckPending() : false;
    }

    function setSeasonalCheckPending(next) {
      if (ctx.setters && ctx.setters.setSeasonalCheckPending) ctx.setters.setSeasonalCheckPending(!!next);
    }

    function getSeasonalConflictMessages() {
      return ctx.getters && ctx.getters.getSeasonalConflictMessages
        ? ctx.getters.getSeasonalConflictMessages()
        : [];
    }

    var PHONE_RULES = {
      '+65': { label: 'Singapore', min: 8, max: 8, pattern: /^[689]\d{7}$/ },
      '+60': { label: 'Malaysia', min: 8, max: 10 },
      '+62': { label: 'Indonesia', min: 8, max: 12 },
      '+66': { label: 'Thailand', min: 8, max: 9 },
      '+63': { label: 'Philippines', min: 10, max: 10 },
      '+84': { label: 'Vietnam', min: 9, max: 10 },
      '+91': { label: 'India', min: 10, max: 10 },
      '+86': { label: 'China', min: 10, max: 11 },
      '+81': { label: 'Japan', min: 9, max: 10 },
      '+82': { label: 'South Korea', min: 8, max: 10 },
      '+852': { label: 'Hong Kong', min: 8, max: 8 },
      '+886': { label: 'Taiwan', min: 8, max: 9 },
      '+61': { label: 'Australia', min: 9, max: 9 },
      '+44': { label: 'United Kingdom', min: 10, max: 10 },
      '+31': { label: 'Netherlands', min: 9, max: 9 },
      '+1': { label: 'US/Canada', min: 10, max: 10 },
    };

    function getPhoneDigits(value) {
      return String(value == null ? '' : value).replace(/\D/g, '');
    }

    function describePhoneLength(rule) {
      if (rule.min === rule.max) return rule.min + ' digits';
      return rule.min + '-' + rule.max + ' digits';
    }

    function validatePhoneNumber(localValue, countryCode) {
      var code = countryCode || '+65';
      var rule = PHONE_RULES[code] || { label: 'selected country', min: 7, max: 12 };
      var raw = String(localValue == null ? '' : localValue).trim();
      var digits = getPhoneDigits(raw);
      if (raw.charAt(0) === '+') {
        var fullDigits = '+' + digits;
        if (fullDigits.indexOf(code) === 0) {
          digits = fullDigits.slice(code.length);
        }
      }

      if (!raw) {
        return { valid: false, empty: true, message: '' };
      }
      if (!digits) {
        return {
          valid: false,
          empty: false,
          message: rule.label + ' phone numbers should use digits.',
        };
      }

      if (digits.length < rule.min || digits.length > rule.max) {
        return {
          valid: false,
          empty: false,
          message: rule.label + ' phone numbers need ' + describePhoneLength(rule) + ' after ' + code + '.',
        };
      }

      if (rule.pattern && !rule.pattern.test(digits)) {
        return {
          valid: false,
          empty: false,
          message: rule.label + ' phone numbers should start with 6, 8, or 9 after ' + code + '.',
        };
      }

      return { valid: true, empty: false, message: '' };
    }

    function updatePhoneHint(inputId, codeId, hintId) {
      var input = getEl(inputId);
      var code = getEl(codeId);
      var hint = getEl(hintId);
      var result = validatePhoneNumber(input ? input.value : '', code ? code.value : '+65');

      if (hint) {
        if (result.valid || result.empty) {
          hint.textContent = '';
          hint.style.display = 'none';
        } else {
          hint.textContent = result.message;
          hint.style.display = 'block';
        }
      }

      return result;
    }

    function isActiveSlotPastCutoff(dateIso) {
      if (!ctx.getters || typeof ctx.getters.isActiveSlotPastCutoff !== 'function') return false;
      return !!ctx.getters.isActiveSlotPastCutoff(dateIso);
    }

    function setSeasonalConflictMessages(next) {
      if (ctx.setters && ctx.setters.setSeasonalConflictMessages) {
        ctx.setters.setSeasonalConflictMessages(Array.isArray(next) ? next : []);
      }
    }

    function checkSeasonalConflicts(dateStr) {
      var seasonalData = getSeasonalData();
      if (!seasonalData || !dateStr) return Promise.resolve([]);
      var doFetch = ctx.deps && typeof ctx.deps.fetch === 'function' ? ctx.deps.fetch : fetch;
      return doFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return [];
          var conflicts = [];
          for (var i = 0; i < cart.items.length; i++) {
            var windows = getSeasonalWindowsForVariant(seasonalData, cart.items[i].variant_id);
            if (windows && windows.length > 0) {
              var withinAny = windows.some(function (w) {
                return dateStr >= w.startDate && dateStr <= w.endDate;
              });
              if (!withinAny) {
                var title = cart.items[i].product_title || windows[0].productTitle || 'A product';
                var windowDesc = windows.map(function (w) {
                  return (w.name || '') + ' (' + w.startDate + ' to ' + w.endDate + ')';
                }).join(', ');
                conflicts.push(title + ' is only available during: ' + windowDesc);
              }
            }
          }
          return conflicts;
        })
        .catch(function () { return []; });
    }

    function runSeasonalConflictCheck(dateStr, seasonalHint) {
      var hintEl = seasonalHint || getEl('wf-ld-seasonal-hint');
      if (!dateStr) {
        setSeasonalConflictMessages([]);
        setSeasonalCheckPending(false);
        if (hintEl) hintEl.style.display = 'none';
        validateAndBlockCheckout();
        return Promise.resolve([]);
      }

      setSeasonalCheckPending(true);
      setSeasonalConflictMessages([]);
      validateAndBlockCheckout();

      var seasonalDataPromise = getSeasonalDataPromise();
      var waitForSeasonal = seasonalDataPromise
        ? seasonalDataPromise.catch(function () { return null; })
        : Promise.resolve();

      return waitForSeasonal
        .then(function () { return checkSeasonalConflicts(dateStr); })
        .then(function (conflicts) {
          var nextConflicts = Array.isArray(conflicts) ? conflicts : [];
          setSeasonalConflictMessages(nextConflicts);
          setSeasonalCheckPending(false);
          if (hintEl) {
            if (nextConflicts.length > 0) {
              hintEl.textContent = nextConflicts.join(' ');
              hintEl.style.display = 'block';
            } else {
              hintEl.style.display = 'none';
            }
          }
          validateAndBlockCheckout();
          return nextConflicts;
        })
        .catch(function () {
          setSeasonalConflictMessages([]);
          setSeasonalCheckPending(false);
          if (hintEl) hintEl.style.display = 'none';
          validateAndBlockCheckout();
          return [];
        });
    }

    function updateDateHints(dateStr) {
      var blackoutHint = getEl('wf-ld-blackout-hint');
      var surchargeHint = getEl('wf-ld-surcharge-hint');
      var seasonalHint = getEl('wf-ld-seasonal-hint');

      if (blackoutHint) {
        var blackout = ctx.getters.isBlackoutDate(dateStr);
        var reason = '';
        var currentConfig = ctx.getters.getConfig();
        if (blackout && currentConfig && currentConfig.blackout_dates) {
          var match = currentConfig.blackout_dates.find(function (b) { return b.date === dateStr; });
          reason = match && match.reason ? match.reason : '';
        }
        blackoutHint.style.display = blackout ? 'block' : 'none';
        if (blackout && reason) {
          blackoutHint.textContent = 'No timeslots available: ' + reason;
        } else if (blackout) {
          blackoutHint.textContent = 'No timeslots available on this date.';
        }
      }

      if (surchargeHint) {
        var surcharge = ctx.getters.getSurchargeForDate(dateStr);
        surchargeHint.style.display = surcharge ? 'block' : 'none';
        if (surcharge) {
          surchargeHint.textContent = 'Peak surcharge: $' + surcharge.amount +
            (surcharge.reason ? ' (' + surcharge.reason + ')' : '');
        }
      }

      if (dateStr) {
        runSeasonalConflictCheck(dateStr, seasonalHint);
      } else if (seasonalHint) {
        seasonalHint.style.display = 'none';
        setSeasonalConflictMessages([]);
        setSeasonalCheckPending(false);
        validateAndBlockCheckout();
      }
    }

    // Section headers get a green tick once all of their required fields pass —
    // a quiet progress signal that replaces the old "Please fill in: ..." list.
    var SECTION_TICKS = [
      { id: 'wf-ld-address-gate', deliveryOnly: true, fields: ['Postal code', 'Valid postal code', 'Recipient address', 'Recipient unit/floor'] },
      { id: 'wf-ld-schedule-step', deliveryOnly: false, fields: ['Delivery date', 'Timeslot', 'Valid delivery date', 'Available timeslot', 'Configured express pricing', 'Configured delivery pricing', 'Seasonal availability check', 'Seasonal date window'] },
      { id: 'wf-ld-recipient-block', deliveryOnly: true, fields: ['Recipient first name', 'Recipient last name', 'Recipient phone', 'Valid recipient phone'] },
      { id: 'wf-ld-sender-block', deliveryOnly: false, fields: ['Sender first name', 'Sender last name', 'Sender email', 'Sender phone', 'Valid sender phone'] },
    ];

    var FIELD_ERROR_DETAILS = {
      'Postal code': { id: 'wf-ld-recipient-postal', label: 'recipient postal code' },
      'Valid postal code': { id: 'wf-ld-recipient-postal', label: 'recipient postal code' },
      'Delivery date': { id: 'wf-ld-date', label: 'delivery date' },
      'Valid delivery date': { id: 'wf-ld-date', label: 'delivery date' },
      'Seasonal availability check': { id: 'wf-ld-date', label: 'delivery date' },
      'Seasonal date window': { id: 'wf-ld-date', label: 'delivery date' },
      'Recipient first name': { selector: 'input[name="attributes[recipient_first_name]"]', label: 'recipient first name' },
      'Recipient last name': { selector: 'input[name="attributes[recipient_last_name]"]', label: 'recipient last name' },
      'Recipient phone': { id: 'wf-ld-recipient-phone', label: 'recipient phone number' },
      'Valid recipient phone': { id: 'wf-ld-recipient-phone', label: 'recipient phone number' },
      'Recipient address': { id: 'wf-ld-recipient-address1', label: 'recipient street address' },
      'Recipient unit/floor': { id: 'wf-ld-recipient-address2', label: 'recipient unit or floor' },
      'Sender first name': { selector: 'input[name="attributes[sender_first_name]"]', label: 'sender first name' },
      'Sender last name': { selector: 'input[name="attributes[sender_last_name]"]', label: 'sender last name' },
      'Sender email': { selector: 'input[name="attributes[sender_email]"]', label: 'sender email' },
      'Sender phone': { id: 'wf-ld-sender-phone', label: 'sender phone number' },
      'Valid sender phone': { id: 'wf-ld-sender-phone', label: 'sender phone number' },
    };
    var revealFieldErrors = false;

    function getFieldErrorDetails(name) {
      if (name === 'Timeslot' || name === 'Available timeslot' || name === 'Configured express pricing' || name === 'Configured delivery pricing') {
        return {
          id: ctx.getters.getActiveTimeslotType() === 'express' ? 'wf-ld-express-timeslot' : 'wf-ld-timeslot',
          label: 'delivery timeslot',
        };
      }
      return FIELD_ERROR_DETAILS[name] || null;
    }

    function getFieldForMissing(name, form) {
      var details = getFieldErrorDetails(name);
      if (!details) return null;
      if (details.id) {
        var field = getEl(details.id);
        if (details.id === 'wf-ld-date' && field && field.type === 'hidden' && typeof field.closest === 'function') {
          var datePickerWrap = field.closest('.wf-dp-wrap');
          var dateDisplay = datePickerWrap && datePickerWrap.querySelector('.wf-dp-display');
          if (dateDisplay) return dateDisplay;
        }
        return field;
      }
      if (details.selector && form && typeof form.querySelector === 'function') {
        return form.querySelector(details.selector);
      }
      return null;
    }

    function updateFieldErrors(missing, form) {
      var previous = form && typeof form.querySelectorAll === 'function'
        ? form.querySelectorAll('.wf-ld-control--invalid')
        : [];
      for (var i = 0; i < previous.length; i++) {
        previous[i].classList.remove('wf-ld-control--invalid');
        previous[i].removeAttribute('aria-invalid');
      }

      var fields = [];
      for (var j = 0; j < missing.length; j++) {
        var field = getFieldForMissing(missing[j], form);
        if (!field || fields.indexOf(field) !== -1) continue;
        fields.push(field);
        field.classList.add('wf-ld-control--invalid');
        field.setAttribute('aria-invalid', 'true');
      }
      return fields;
    }

    function focusInvalidField(field) {
      if (!field) return;
      if (typeof field.scrollIntoView === 'function') {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        field.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
      function applyFocus() {
        if (typeof field.focus !== 'function') return;
        try {
          field.focus({ preventScroll: true });
        } catch (e) {
          field.focus();
        }
      }
      applyFocus();
      setTimeout(applyFocus, 50);
    }

    function updateSectionTicks(missing, isDelivery) {
      var missingSet = {};
      for (var i = 0; i < missing.length; i++) missingSet[missing[i]] = true;
      SECTION_TICKS.forEach(function (section) {
        var el = getEl(section.id);
        if (!el || !el.classList) return;
        var applies = isDelivery || !section.deliveryOnly;
        var complete = applies;
        if (applies) {
          for (var j = 0; j < section.fields.length; j++) {
            if (missingSet[section.fields[j]]) { complete = false; break; }
          }
        }
        el.classList.toggle('wf-ld-step--complete', complete);
      });
    }

    function validateAndBlockCheckout(options) {
      options = options || {};
      var form = getForm();
      if (!form) return { valid: false, missing: [], firstInvalidField: null };
      if (options.revealErrors) revealFieldErrors = true;
      var methodDelivery = getEl('wf-ld-method-delivery');
      var isDelivery = methodDelivery && methodDelivery.checked;
      var postalInput = getEl('wf-ld-recipient-postal');
      var dateVal = ctx.getters.getSelectedDateIso();
      var slotVal = ctx.getters.getActiveTimeslotValue();

      var missing = [];

      if (isDelivery) {
        var code = postalInput ? postalInput.value.trim() : '';
        if (code.length !== 6) {
          missing.push('Postal code');
        } else {
          var currentConfig = ctx.getters.getConfig();
          if (currentConfig) {
            var r = ctx.deps.POSTAL.validatePostalClient(
              code,
              currentConfig.excluded_areas,
              currentConfig.excluded_postal_prefixes,
              currentConfig.allowed_postal_exceptions,
              dateVal,
              currentConfig.scheduled_postal_exclusions
            );
            if (!r.valid || r.excluded) missing.push('Valid postal code');
          }
        }
      }
      if (!dateVal) missing.push('Delivery date');
      if (!slotVal) missing.push('Timeslot');
      if (dateVal && !ctx.getters.isDateAllowed(dateVal)) missing.push('Valid delivery date');
      if (slotVal && !ctx.getters.isSelectedTimeslotValid()) missing.push('Available timeslot');
      if (slotVal && dateVal && isActiveSlotPastCutoff(dateVal)) missing.push('Available timeslot');

      var expressSelectionError = ctx.getters.getExpressSelectionError();
      if (slotVal && expressSelectionError) {
        missing.push(ctx.getters.getActiveTimeslotType() === 'express' ? 'Configured express pricing' : 'Configured delivery pricing');
      }
      if (getSeasonalCheckPending()) missing.push('Seasonal availability check');
      var seasonalConflicts = getSeasonalConflictMessages();
      if (seasonalConflicts.length > 0) missing.push('Seasonal date window');

      if (isDelivery) {
        if (!ctx.getters.getFormVal('recipient_first_name')) missing.push('Recipient first name');
        if (!ctx.getters.getFormVal('recipient_last_name')) missing.push('Recipient last name');
        var rPhoneInp = getEl('wf-ld-recipient-phone');
        if (!rPhoneInp || !rPhoneInp.value.trim()) {
          updatePhoneHint('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code', 'wf-ld-recipient-phone-hint');
          missing.push('Recipient phone');
        } else if (!updatePhoneHint('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code', 'wf-ld-recipient-phone-hint').valid) {
          missing.push('Valid recipient phone');
        }
        if (!ctx.getters.getFormVal('recipient_address1')) missing.push('Recipient address');
        if (!ctx.getters.getFormVal('recipient_address2')) missing.push('Recipient unit/floor');
      }

      if (!ctx.getters.getFormVal('sender_first_name')) missing.push('Sender first name');
      if (!ctx.getters.getFormVal('sender_last_name')) missing.push('Sender last name');
      if (!ctx.getters.getFormVal('sender_email')) missing.push('Sender email');
      var sPhoneInp = getEl('wf-ld-sender-phone');
      if (!sPhoneInp || !sPhoneInp.value.trim()) {
        updatePhoneHint('wf-ld-sender-phone', 'wf-ld-sender-phone-code', 'wf-ld-sender-phone-hint');
        missing.push('Sender phone');
      } else if (!updatePhoneHint('wf-ld-sender-phone', 'wf-ld-sender-phone-code', 'wf-ld-sender-phone-hint').valid) {
        missing.push('Valid sender phone');
      }

      updateSectionTicks(missing, isDelivery);

      var invalidFields = revealFieldErrors ? updateFieldErrors(missing, form) : [];
      var firstInvalidField = invalidFields.length > 0 ? invalidFields[0] : null;
      if (options.focusFirstInvalid) focusInvalidField(firstInvalidField);

      var hint = getEl('wf-ld-checkout-hint');
      var btn = getEl('wf-ld-checkout') || form.querySelector('#checkout');
      var proxyBtn = getCheckoutProxyButton();
      // Keep the HF checkout button clickable as a validation trigger. Any theme
      // proxy stays truly disabled until the form is complete.
      var visibleCheckoutBtn = document.getElementById('checkout-submit');
      if (missing.length > 0) {
        if (btn) {
          btn.disabled = false;
          btn.classList.add('wf-ld-checkout--blocked');
        }
        if (proxyBtn) proxyBtn.disabled = true;
        if (visibleCheckoutBtn) {
          visibleCheckoutBtn.classList.add('wf-checkout-cta--blocked');
          visibleCheckoutBtn.setAttribute('aria-disabled', 'true');
          visibleCheckoutBtn.disabled = true;
        }
        if (hint) {
          var blockingHint = expressSelectionError;
          if (!blockingHint && getSeasonalCheckPending()) blockingHint = 'Checking seasonal availability...';
          if (!blockingHint && seasonalConflicts.length > 0) blockingHint = seasonalConflicts.join(' ');
          if (!blockingHint && slotVal && dateVal && isActiveSlotPastCutoff(dateVal)) {
            blockingHint = 'Selected timeslot cutoff has passed. Please choose another timeslot.';
          }
          if (!blockingHint && revealFieldErrors && missing.length > 0) {
            var firstDetails = getFieldErrorDetails(missing[0]);
            blockingHint = 'Please complete the highlighted ' + (firstDetails ? firstDetails.label : 'field') + ' before checkout.';
          }
          if (blockingHint) {
            hint.textContent = blockingHint;
            hint.style.display = 'block';
          } else {
            hint.textContent = '';
            hint.style.display = 'none';
          }
        }
      } else {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('wf-ld-checkout--blocked');
        }
        if (proxyBtn) proxyBtn.disabled = false;
        if (visibleCheckoutBtn) {
          visibleCheckoutBtn.classList.remove('wf-checkout-cta--blocked');
          visibleCheckoutBtn.setAttribute('aria-disabled', 'false');
          visibleCheckoutBtn.disabled = false;
        }
        if (hint) {
          hint.textContent = '';
          hint.style.display = 'none';
        }
      }
      return { valid: missing.length === 0, missing: missing, firstInvalidField: firstInvalidField };
    }

    function getSeasonalState() {
      return {
        seasonalCheckPending: getSeasonalCheckPending(),
        seasonalConflictMessages: getSeasonalConflictMessages(),
      };
    }

    return {
      checkSeasonalConflicts: checkSeasonalConflicts,
      runSeasonalConflictCheck: runSeasonalConflictCheck,
      updateDateHints: updateDateHints,
      validateAndBlockCheckout: validateAndBlockCheckout,
      updatePhoneHint: updatePhoneHint,
      validatePhoneNumber: validatePhoneNumber,
      getSeasonalState: getSeasonalState,
    };
  }

  window.WF_LD_CART_VALIDATION = {
    createValidationController: createValidationController,
  };
})();
